import config from '@/core/config/config';
import { CurrentUser } from '@/types';
import { getAppLinksForUser } from '@/utils/getAppLinksForUser';

interface UserPopoverMenuProps {
  user: CurrentUser;
}

interface LinkProps {
  url: string;
  label: string;
}

const UserPopoverMenu = ({ user }: UserPopoverMenuProps) => {
  const { firstname, lastname, roles } = user;
  const userAppLinks = getAppLinksForUser(roles);

  return (
    <nav>
      <>
        <p className="font-bold">Apps</p>
        <ul>
          {userAppLinks.map((link: LinkProps) => (
            <li key={link.label}>
              <a href={link.url} arial-label={link.label}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </>
      <p className="mt-2 font-bold">{`${firstname} ${lastname}`}</p>
      <ul>
        <li>
          <a href={`${config.BASE_URL}/user/profile`} aria-label="Profile">
            Profile
          </a>
        </li>
        <li>
          <a href={`${config.BASE_URL}/logout`} aria-label="Logout">
            Log Out
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default UserPopoverMenu;
